// @flow

import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';

import type { JSONObject, JSONArray } from 'common/types';

import type {
  JSONAPIPayload,
  JSONAPIResource,
  JSONAPIRelationships
} from 'common/jsonApi/types';

// FIXME: This is scary
const relationshipDataToAttributes = (relationships: JSONAPIRelationships) => {
  const attributes = {};
  Object.keys(relationships).forEach(relName => {
    const relData = relationships[relName].data;
    if (Array.isArray(relData)) {
      attributes[
        `${relName.substring(0, relName.length - 1)}Ids`
      ] = relData.map(d => d.id);
    } else {
      attributes[`${relName}Id`] = (relData && relData.id) || null;
      if (relData && relData.type && `${relName}s` !== relData.type) {
        attributes[`${relName}Type`] = relData.type;
      }
    }
  });
  return attributes;
};

function normalizeResource(resource: JSONAPIResource): JSONObject {
  const { id } = resource;
  const attributes = resource.attributes || {};
  const relationshipAttributes = relationshipDataToAttributes(
    resource.relationships || {}
  );
  return {
    ...attributes,
    id,
    ...relationshipAttributes
  };
}

const dataResourcesFromPayload = (
  json: JSONAPIPayload
): Array<JSONAPIResource> => {
  if (!json.data) {
    return [];
  }
  if (Array.isArray(json.data)) {
    return json.data;
  }
  return [json.data];
};

const includedResourcesFromPayload = (
  json: JSONAPIPayload
): Array<JSONAPIResource> => json.included || [];

function unnormalizedResourcesFromJsonApiPayload(
  json: JSONAPIPayload
): Array<JSONAPIResource> {
  const dataResources = dataResourcesFromPayload(json);
  const includedResources = includedResourcesFromPayload(json);
  return dataResources.concat(includedResources);
}

type ResourcesByType = { [type: string]: JSONArray, ... };

export default function normalizeJsonApiResources(
  json: JSONAPIPayload
): ResourcesByType {
  const resources = unnormalizedResourcesFromJsonApiPayload(json);
  const unnormalizedResourcesByType = groupBy(resources, r => r.type);
  return mapValues(unnormalizedResourcesByType, unnormalizedResources =>
    unnormalizedResources.map(normalizeResource)
  );
}
